import { InjectionToken } from '@angular/core';

export interface SupportedEvmChain {
  chainId: number;
  chainIdHex: `0x${string}`;
  name: string;
}

/** Provides frontend-supported EVM chains; an empty list means no chain restriction. */
export const SUPPORTED_EVM_CHAINS = new InjectionToken<readonly SupportedEvmChain[]>('Supported EVM chains', {
  providedIn: 'root',
  factory: () => [],
});
